import React, { useState } from 'react';
import {
  withStyles,
  Modal,
  Typography,
  Fab,
  TextField,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import NumberFormat from 'react-number-format';
import {
  Card, CardBody, CardHeader, CardIcon,
} from '~/components/Card';
import {
  updateTruckAllocations,
  updateIsTruckAllocationLoading,
} from '~/store/dispatch/actions';
import styles from '../../styles';


const ALLOCATION_MODES = {
  STANDARD: 'standard',
  TEMPORARY: 'temp',
};

const TruckAllocationModeModal = ({
  isOpen,
  close,
  classes,
  refreshOrigins,
  container,
}) => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const pendingTruckAllocationUpdate = useSelector(
    state => state.dispatch.pendingTruckAllocationUpdate,
  );

  const [radioValue, setRadioValue] = useState(ALLOCATION_MODES.STANDARD);
  const [tempFieldValue, setTempFieldValue] = useState(5);

  const handleClose = () => {
    dispatch(updateIsTruckAllocationLoading(false));
    close();
  };

  const renderHeader = () => (
    <div>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
      >
        {`${translate('common:AllocationMode')}`}
      </Typography>
    </div>
  );

  return (
    <Modal
      open={isOpen}
      onClose={(event, reason) => reason === 'backdropClick' && handleClose()}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      container={container || document.body}
    >
      <div style={{ width: 400 }}>
        <Card>
          <CardHeader icon>
            <>
              <CardIcon
                onClick={handleClose}
                style={{
                  float: 'right',
                  cursor: 'pointer',
                  background: 'darkgray',
                  borderRadius: 50,
                  boxShadow: '10px 10px 50px gray',
                }}
              >
                <CloseIcon />
              </CardIcon>
            </>
          </CardHeader>
          <CardBody>
            <div />
            <div>
              {renderHeader()}
              <hr />
              <RadioGroup
                name="allocationmode"
                value={radioValue}
                onChange={event => setRadioValue(event.target.value)}
                style={{ padding: 10 }}
              >
                <FormControlLabel value={ALLOCATION_MODES.STANDARD} control={<Radio />} label={translate('common:Standard')} />
                <FormControlLabel value={ALLOCATION_MODES.TEMPORARY} control={<Radio />} label={translate('common:Temporary')} />
              </RadioGroup>
              {radioValue === ALLOCATION_MODES.TEMPORARY && (
                <div style={{ display: 'flex' }}>
                  <NumberFormat
                    customInput={TextField}
                    value={tempFieldValue}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={e => setTempFieldValue(e.target.value)}
                    style={{ width: 70, paddingLeft: 10 }}
                    disabled={radioValue === ALLOCATION_MODES.STANDARD}
                    decimalScale={0}
                  />
                  <Typography
                    style={{
                      marginLeft: 5, display: 'flex', alignItems: 'flex-end', textTransform: 'lowercase',
                    }}
                  >
                    {translate('common:Cycles')}
                  </Typography>
                </div>
              )}
            </div>
            <div style={{
              display: 'flex',
              marginTop: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            >
              <Fab
                variant="extended"
                size="medium"
                color="secondary"
                onClick={() => {
                  const newTruckAllocation = {
                    ...pendingTruckAllocationUpdate,
                    cycles: (radioValue === ALLOCATION_MODES.TEMPORARY
                      ? parseInt(tempFieldValue || 0, 10) : null),
                  };
                  dispatch(updateTruckAllocations({
                    item: newTruckAllocation,
                    key: 'load_allocation_id',
                    value: newTruckAllocation.load_allocation_id,
                    refresh: refreshOrigins,
                    dispatchLoading: true,
                  }));
                  close();
                }}
                className={classes.saveButton}
              >
                {translate('common:Confirm')}
              </Fab>
            </div>
          </CardBody>
        </Card>
      </div>
    </Modal>
  );
};

TruckAllocationModeModal.propTypes = {
  classes: PropTypes.object.isRequired,
  close: PropTypes.func,
  isOpen: PropTypes.bool,
  refreshOrigins: PropTypes.bool,
  container: PropTypes.element,
};

TruckAllocationModeModal.defaultProps = {
  isOpen: false,
  close: () => null,
  refreshOrigins: false,
  container: null,
};

export default withStyles(styles)(TruckAllocationModeModal);
